import styles from "./style.module.scss";
import VLProgressBar from "views/uikit/ProgressBars/VLProgressBar";
import classNames from "classnames";
import TextWithTooltip from "views/components/TextWithTooltip";
import { Tooltip } from "antd";

export interface ProgressCardProps {
  label?: string;
  maxItems: number;
  itemLength: number;
  active?: boolean;
  onClick?: (id: string) => void;
  id: string;
  type?: string;
}

const getReviewState = (
  itemLength: number,
  maxItems: number,
  type?: string,
): "pendingReview" | "completedReview" | null => {
  if (type === "TRAIN_GOAL") return null;
  return itemLength < maxItems ? "pendingReview" : "completedReview";
};

export default function ProgressCard({
  label,
  maxItems,
  itemLength,
  active = false,
  onClick,
  id,
  type,
}: ProgressCardProps) {
  const reviewState = getReviewState(itemLength, maxItems, type);

  const wrapperClass = classNames(
    styles.wrapper,
    reviewState && styles[reviewState],
    active && reviewState && styles[`selected`],
  );

  const reviewColors: Record<
    "pendingReview" | "completedReview",
    "warning" | "success"
  > = {
    pendingReview: "warning",
    completedReview: "success",
  };

  const color = reviewState ? reviewColors[reviewState] : "default";

  const countTooltip =
    type === "TRAIN_GOAL"
      ? `${itemLength} labeled images out of the ${maxItems} needed for this label to be Train-Worthy`
      : `${itemLength} of ${maxItems} images reviewed for this label in the current batch`;

  return (
    <div className={styles.cardWrapper} data-testid="progress-card">
      <div
        className={wrapperClass}
        onClick={() => {
          onClick?.(id);
        }}
        data-testid="progress-card-wrapper"
      >
        <div className={styles.headers}>
          {label && <TextWithTooltip text={label} />}
          <Tooltip title={countTooltip} mouseEnterDelay={0.4}>
            <div data-testid="progress-card-count" className={styles.itemCount}>
              {itemLength} / {maxItems}
            </div>
          </Tooltip>
        </div>
        <div>
          <VLProgressBar
            itemLength={itemLength}
            maxItems={maxItems}
            color={color}
          />
        </div>
      </div>
    </div>
  );
}
